import { render, staticRenderFns } from "./clipModal.vue?vue&type=template&id=58472fe4&"
import script from "./clipModal.vue?vue&type=script&lang=js&"
export * from "./clipModal.vue?vue&type=script&lang=js&"
import style0 from "./clipModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports